import { signal } from "@preact/signals-react";
import { logClientNumber, logToken } from "./login.signal";

export const ProfileData = signal(null);

export async function fetchProfileApi() {
  const url = "https://alguthmi.co/API/B2BAppAPI/fetchProfileData.php";
  const bearerToken = logToken.value;

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      CLICODE: logClientNumber.value,
    }),
  };

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
  }
}
